import React, { ReactNode, useState } from 'react';
import { actionBarMinWidthWrapper } from 'src/components/common/common';

interface InfoSectionDoubleFormProps {
	children: ReactNode;
	expandSearch?: () => ReactNode;
	buttonText?: string; // 버튼 텍스트를 커스터마이징할 수 있는 prop
}

export const InfoSectionDoubleForm: React.FC<InfoSectionDoubleFormProps> = ({ children, expandSearch, buttonText = '상세검색' }) => {
	const [isExpanded, setIsExpanded] = useState(false);
	const height = '80';

	return (
    <div className={`w-full flex items-start gap-[6px] overflow-x-auto`}>
        <div className={`w-full flex flex-col transition-all duration-500 `}>
            <div className={`w-full flex flex-wrap gap-x-[12px] gap-y-[4px] border-gray-300 pt-[8px] px-[12px] py-[4px] mb-[4px] border overflow-x-auto ${actionBarMinWidthWrapper}`}>
                {React.Children.map(children, (child) => {
                    const isSpacer = (() => {
                        if (!React.isValidElement(child)) return false;
                        const typeAny: any = child.type as any;
                        return typeAny?.displayName === 'SearchSpacer' || typeAny?.name === 'SearchSpacer';
                    })();
                    const wrapperClass = isSpacer ? 'w-full' : '';
                    return (
                        <div className={`${wrapperClass} flex-shrink-0`}>
                            {child}
                        </div>
                    );
                })}
                {expandSearch && 
                    <div className="w-full flex justify-end">
                        <button 
                            onClick={() => {
                                setIsExpanded(!isExpanded);
                            }} 
                            className={`bg-white hover:bg-gray-100 border border-gray-300 text-gray-800 font-semibold px-4 rounded shadow h-[30px]`}
                        >
                            {buttonText}
                        </button>
                    </div>
                }
            </div>
			{expandSearch &&
				<div className={`
					transition-[height] duration-500 ease-in-out overflow-hidden
					${isExpanded ? `h-[${height}px]` : 'h-0'}`}>
                    <div className={`
                        w-full h-full grid grid-cols-12 gap-x-[8px] gap-y-[8px]
                        border-gray-300 ${actionBarMinWidthWrapper} border py-[4px]
                        transition-opacity duration-300 ease-in-out
                        ${isExpanded ? 'opacity-100' : 'opacity-0'}
                    `}>
						{expandSearch()}
					</div>
				</div>
			}
			</div>
    </div>
	);
};